import React from 'react';
import styled from 'styled-components/macro';
import WatchListIcon from 'components/Icons/menu-volia/watchlist';
import scaleSize from 'utils/scale-size';
import Button from 'components/Button';
import i18n from 'i18n';
import { FocusableParent } from 'components/navigation';
import { useHistory } from 'react-router';

const StyledWrapper = styled.div`
  width: ${scaleSize(1500)}px;
  height: ${scaleSize(1080)}px;
  display: table;
`;
const StyledContent = styled(FocusableParent)`
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  font-size: ${scaleSize(40)}px;
  line-height: 1.2;
  color: ${({ theme }) => theme.iconDefaultColor};
  svg {
    width: ${scaleSize(192)}px;
    height: ${scaleSize(192)}px;
  }
`;
const StyledBottom = styled(Button)`
  margin: ${scaleSize(50)}px 0 0;
`;
export const NotLoggedStub = ({ className }) => {
  const history = useHistory();

  const onLoginEnter = () => history.push('/login');

  return (
    <StyledWrapper className={className}>
      <StyledContent id="login-stub" sectionName="Login_STUB" defaultSection>
        <div>
          <WatchListIcon width={192} height={192} />
          <div>Log in to watch this page</div>
        </div>
        <StyledBottom id="login-bottom" onEnter={onLoginEnter}>
          {i18n.t('common.login')}
        </StyledBottom>
      </StyledContent>
    </StyledWrapper>
  );
};

export default NotLoggedStub;
